import { AccessibleElement } from 'types/widget.types';

import { ResponsiveWidgetBaseData } from '../ResponsiveWidgetBase.types';

enum ComponentWidgetIdKeys {
  QuestionText = 'questionText',
  AnswerText = 'answerText',
}

enum MultipleChoicesType {
  Horizontal = 'Horizontal',
  Vertical = 'Vertical',
}

interface MultipleChoicesWidgetData extends ResponsiveWidgetBaseData<ComponentWidgetIdKeys>, AccessibleElement {
  type: MultipleChoicesType;
  correctAnswers: string[]; // Correct answers by the editor
  selectedAnswers: string[]; // Selected answers by the user
  enableMultipleSelection: boolean; // Whether the user can select multiple answers
  submitTextColor: string;
  submitBackgroundColor: string;
}

/**
 * Multiple Choices Widget SideMenu Settings
 */
enum ACCORDION_INDICIES {
  QUESTION,
  STYLE,
  LAYOUT,
}

export type { MultipleChoicesWidgetData };
export { MultipleChoicesType, ComponentWidgetIdKeys, ACCORDION_INDICIES };
